import { useQuest } from "@/context/QuestProvider";
import { RESET_QUEST } from "@/context/QuestProvider/actions";
import type { QuestState } from "@ui-kit/QuestList";
import {
  type Dispatch,
  type MutableRefObject,
  type SetStateAction,
  useCallback,
} from "react";

export const useResetQuest = (
  revalidateGemsAmount: () => void,
  asyncCompleteHandler: MutableRefObject<(() => Promise<unknown>) | undefined>,
  setSelectedQuest: Dispatch<SetStateAction<QuestState | undefined>>,
) => {
  const { dispatchAction } = useQuest((store) => store);
  const resetQuest = useCallback(
    (resetInProgress = false) => {
      setSelectedQuest(undefined);
      revalidateGemsAmount();

      if (asyncCompleteHandler.current && !resetInProgress) {
        return;
      }

      asyncCompleteHandler.current = undefined;
      dispatchAction({ type: RESET_QUEST });
    },
    [
      dispatchAction,
      revalidateGemsAmount,
      asyncCompleteHandler,
      setSelectedQuest,
    ],
  );

  return { resetQuest };
};
